<template>
  <el-container class="tycOrderRefund">
    <el-header class="header-style">
      <el-divider content-position="left">退款申请</el-divider>
      <el-row>
        <el-col :span="15" style="padding-top: 0.14rem">
          <span>总数：{{ refundCount }}</span>
          <span class="ml-10">今日申请：{{ todayCount }}</span>
          <span class="ml-10">昨日申请：{{ yesterday }}</span>
          <span class="ml-10">今日审核：{{ todayVerify }}</span>
          <span class="ml-10">昨日审核：{{ yesterdayVerify }}</span>
        </el-col>
        <el-col :span="7" class="tr">
          <el-input
            v-model="searchArr.refund_order"
            filterable
            remote
            reserve-keyword
            placeholder="关键词：订单号、客户姓名、客户手机号"
            size="mini"
            clearable
            @change="handleSearchCfcategory"
          >
          </el-input>
        </el-col>
        <el-col :span="1" :offset="1" class="tr">
          <!-- <el-button v-if="pageNodes.indexOf('分配') !== -1" type="primary" size="mini" @click="handleAssign">分配</el-button> -->
          <el-button
            v-if="pageNodes.indexOf('导出') !== -1"
            type="primary"
            size="mini"
            @click="handleExport"
            >导出</el-button
          >
        </el-col>
      </el-row>
      <el-collapse v-model="activeOpen">
        <el-collapse-item title="高级筛选" name="1">
          <div style="padding: 10px">
            <el-row class="search-row" :gutter="20">
              <el-col :xs="24" :sm="4" :md="3" :lg="2"><span>派单时间</span></el-col>
              <el-col :xs="24" :sm="8" :md="5" :lg="6">
                <el-date-picker
                  size="mini"
                  v-model="searchArr.assign_at"
                  type="daterange"
                  :picker-options="assignPicker"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </el-col>
              <el-col :xs="24" :sm="4" :md="3" :lg="2"><span>申请时间</span></el-col>
              <el-col :xs="24" :sm="8" :md="5" :lg="6">
                <el-date-picker
                  size="mini"
                  v-model="searchArr.refund_date"
                  type="daterange"
                  :picker-options="refundPicker"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </el-col>

              <el-col :xs="24" :sm="4" :md="3" :lg="2"><span>是否会员</span></el-col>
              <el-col :xs="24" :sm="8" :md="5" :lg="6">
                <el-radio-group v-model="searchArr.is_member" size="mini">
                  <el-radio-button label="y">是</el-radio-button>
                  <el-radio-button label="n">否</el-radio-button>
                </el-radio-group>
              </el-col>
            </el-row>
            <el-row class="search-row" :gutter="20">
              <el-col :xs="24" :sm="4" :md="3" :lg="2"><span>沟通顾问</span></el-col>
              <el-col :xs="24" :sm="8" :md="5" :lg="6">
                <el-cascader
                  style="width: 100%"
                  v-model="searchArr.consultant"
                  placeholder="请选择沟通顾问"
                  :options="personnel"
                  size="mini"
                  :props="{ expandTrigger: 'hover' }"
                  clearable
                  filterable
                  :filter-method="filterOptions"
                >
                </el-cascader>
              </el-col>
              <el-col :xs="24" :sm="4" :md="3" :lg="2"><span>转化人员</span></el-col>
              <el-col :xs="24" :sm="8" :md="5" :lg="6">
                <el-cascader
                  style="width: 100%"
                  v-model="searchArr.convert"
                  placeholder="请选择转化人员"
                  :options="personnelConvert"
                  size="mini"
                  :props="{ expandTrigger: 'hover' }"
                  clearable
                  filterable
                  :filter-method="filterOptions"
                >
                </el-cascader>
              </el-col>
              <el-col :xs="24" :sm="4" :md="3" :lg="2"><span>申请人员</span></el-col>
              <el-col :xs="24" :sm="8" :md="5" :lg="6">
                <el-cascader
                  style="width: 100%"
                  v-model="searchArr.refunder"
                  placeholder="请选择申请人员"
                  :options="personnel"
                  size="mini"
                  :props="{ expandTrigger: 'hover' }"
                  clearable
                  filterable
                  :filter-method="filterOptions"
                >
                </el-cascader>
              </el-col>
            </el-row>
            <el-row class="search-row" :gutter="20">
              <el-col :xs="24" :sm="4" :md="3" :lg="2"><span>退款状态</span></el-col>
              <el-col :xs="24" :sm="8" :md="5" :lg="6">
                <el-select
                  v-model="searchArr.refund_status"
                  filterable
                  placeholder="请选择"
                  clearable
                  size="mini"
                >
                  <el-option :value="2" label="退款申请中"></el-option>
                  <el-option :value="3" label="已退款"></el-option>
                </el-select>
              </el-col>
              <el-col :xs="24" :sm="4" :md="3" :lg="2"><span>退款原因</span></el-col>
              <el-col :xs="24" :sm="8" :md="5" :lg="6">
                <el-select
                  v-model="searchArr.refund_cause_id"
                  size="mini"
                  multiple
                  clearable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="cause in causes"
                    :key="cause.refund_id"
                    :label="cause.refund_cause"
                    :value="cause.refund_id"
                  >
                  </el-option>
                </el-select>
              </el-col>

              <el-col :xs="24" :sm="4" :md="3" :lg="2"><span>原因一致</span></el-col>
              <el-col :xs="24" :sm="8" :md="5" :lg="6">
                <el-select
                  v-model="searchArr.fit"
                  filterable
                  placeholder="请选择"
                  clearable
                  size="mini"
                >
                  <el-option :value="1" label="否"></el-option>
                  <el-option :value="2" label="是"></el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row class="tc">
              <el-button type="primary" size="mini" @click="handleASearSub"
                >查询</el-button
              >
              <el-button type="danger" size="mini" @click="handleASearClear"
                >清除</el-button
              >
            </el-row>
          </div>
        </el-collapse-item>
      </el-collapse>
    </el-header>

    <el-main class="main-style">
      <el-table
      height="calc(100vh - 306px)"
        :data="pageData"
        size="medium"
        style="width: 100%"
        ref="multipleTable"
        @selection-change="handleSelectionChange"
        border
      >
        <el-table-column type="selection" fixed></el-table-column>
        <el-table-column
          v-for="(item, index) in col"
          :key="index"
          :label="item.label"
          :prop="item.prop"
          :sortable="item.sort"
          :fixed="item.fixed"
          :width="tableColumn(item.prop)"
          :show-overflow-tooltip = item.tooltip
        >
          <template slot-scope="scope">
            <div v-if="item.prop === 'refunder'">
              <span class="hide-style">{{
                scope.row.refund_per ? scope.row.refund_per.username : ""
              }}</span>
            </div>
            <div v-else-if="item.prop === 'trans'">
              <span class="hide-style">{{
                scope.row.trans ? scope.row.trans.username : ""
              }}</span>
            </div>
            <div v-else-if="item.prop === 'advisor'">
              <span class="hide-style">{{
                scope.row.advisor ? scope.row.advisor.username : ""
              }}</span>
            </div>
            <div v-else-if="item.prop === 'reviewer'">
              <span class="hide-style">{{
                scope.row.reviewer ? scope.row.reviewer.username : ""
              }}</span>
            </div>
            <div v-else-if="item.prop === 'order_reg'">
              <span class="hide-style">{{
                scope.row.order_reg ? scope.row.order_reg.order_reg_name : ""
              }}</span>
            </div>
            <div v-else-if="item.prop === 'contact_time'">
              <span class="hide-style">
              <!-- {{ scope.row.order_reg ? scope.row.order_reg.order_reg_name : "" }} -->
              <date-formatter :date-value="scope.row.contact_time"></date-formatter>
              </span>
            </div>
            <div v-else-if="item.prop === 'customer_phone'">
              <!-- <span class="count-style">{{
                scope.row.customer_phone
                  ? scope.row.customer_phone.substring(0, 5) + "..."
                  : ""
              }}</span> -->
              <phone-com :comPhone="scope.row.customer_phone" :vagaryPhone="scope.row.vagary_phone_custome"
                  style="display: inline-block;" />
            </div>
            <span v-else-if="item.prop === 'is_member'">
              <el-tooltip
                content="点击查看会员信息"
                placement="top"
                v-if="scope.row.is_member"
              >
                <span class="count_style" style="display: inherit"
                  ><el-link
                    ><strong
                      style="color: #409eff"
                      @click="
                        openMemberInfoDrawer(
                          scope.row.customer_phone_code
                            ? scope.row.customer_phone_code
                            : scope.row.vagary_phone
                        )
                      "
                      >是</strong
                    ></el-link
                  ></span
                >
              </el-tooltip>
              <span class="count_style" style="display: inherit" v-else>否</span>
            </span>
            <span v-else-if="item.prop === 'order_status'">
              <el-tag v-if="scope.row.order_status === '申请退款中'" type="warning">{{
                scope.row.order_status
              }}</el-tag>
              <el-tag v-if="scope.row.order_status === '已退款'" type="success">{{
                scope.row.order_status
              }}</el-tag>
            </span>
            <div v-else>
              <el-link
                class="ellipsis-link"
                v-if="item.prop === 'order_num'"
                type="primary"
                @click="handelFeedbackOpen(scope.$index, scope.row.id)"
                >{{ scope.row.order_num }}</el-link
              >
              <span v-else class="hide-style">{{ scope.row[item.prop] }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="200">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" content="审核" placement="top">
              <el-button
                :type="scope.row.refund_status === 0 ? 'info' : 'success'"
                :icon="
                  scope.row.refund_status === 0 ? 'el-icon-edit-outline' : 'el-icon-check'
                "
                size="mini"
                circle
                @click="handelReview(scope.$index, scope.row)"
              ></el-button>
            </el-tooltip>
            <el-tooltip
              class="item ml-10"
              effect="dark"
              :content="scope.row.refund_status > 1 ? '已提交' : '提交申请'"
              placement="top"
            >
              <el-popconfirm
                title="确定完成申请吗？"
                @onConfirm="handelRefundSubmit(scope.$index, scope.row)"
              >
                <el-button
                  slot="reference"
                  :type="scope.row.refund_status < 2 ? 'primary' : 'success'"
                  :icon="
                    scope.row.refund_status < 2 ? 'el-icon-edit-outline' : 'el-icon-check'
                  "
                  size="mini"
                  circle
                  :disabled="scope.row.refund_status !== 1"
                ></el-button>
              </el-popconfirm>
            </el-tooltip>
            <el-tooltip
              class="ml-10"
              effect="dark"
              :content="scope.row.refund_status > 2 ? '已完成' : '确认完成'"
              placement="top"
            >
              <el-popconfirm
                title="确定完成退款吗？"
                @onConfirm="handelComplete(scope.$index, scope.row)"
              >
                <el-button
                  slot="reference"
                  :type="scope.row.refund_status < 3 ? 'warning' : 'success'"
                  :icon="
                    scope.row.refund_status < 3 ? 'el-icon-edit-outline' : 'el-icon-check'
                  "
                  size="mini"
                  circle
                  :disabled="scope.row.refund_status !== 2"
                ></el-button>
              </el-popconfirm>
            </el-tooltip>

            <el-tooltip
              class="item ml-10"
              effect="dark"
              content="驳回申请"
              placement="top"
            >
              <el-popconfirm
                title="确定驳回申请吗？"
                @onConfirm="handelRefundRefuse(scope.$index, scope.row)"
              >
                <el-button
                  slot="reference"
                  type="primary"
                  icon="el-icon-close"
                  size="mini"
                  circle
                ></el-button>
              </el-popconfirm>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </el-main>

    <el-footer class="footer-style">
      <el-pagination
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        :hide-on-single-page="false"
        :current-page="pageOption.currentPage"
        layout="sizes, total, prev, pager, next, jumper"
        :total="pageOption.total"
        :page-sizes="[10, 20, 30, 50, 100, 500]"
        :page-size="pageOption.pageSize"
        background
      >
      </el-pagination>
    </el-footer>

    <el-drawer
      :title="'订单信息： ' + orderContent.order_num"
      :visible.sync="logDrawer"
      direction="rtl"
      custom-class="AIdrawer"
      :before-close="handleLogBeforeClose"
      size="50%"
    >
    <div class="drawer-title" slot="title">订单信息： {{ orderContent.order_num }}</div>
      <div class="m-tabs-content">
        <el-tabs v-model="activeName">
          <el-tab-pane label="基本信息" name="info">
            <el-row class="m-tab">
              <el-col :span="4" class="m-th">
                <el-tooltip content="订单号" placement="top"
                  ><span class="count-style">订单号</span>
                </el-tooltip>
              </el-col>
              <el-col :span="20" class="m-td">
                <span style="cursor: pointer" @click="copyUrl(orderContent.order_num)">{{
                  orderContent.order_num
                }}</span>
              </el-col>
              <el-col :span="4" class="m-th">
                <el-tooltip content="来源" placement="top"
                  ><span class="count-style">来源</span></el-tooltip
                >
              </el-col>
              <el-col :span="8" class="m-td">
                <span>{{ orderSources }}</span>
              </el-col>
              <el-col :span="4" class="m-th">
                <el-tooltip content="金额" placement="top"
                  ><span class="count-style">金额</span></el-tooltip
                >
              </el-col>
              <el-col :span="8" class="m-td">
                <span>{{ orderContent.total_amount }}</span>
              </el-col>
              <el-col :span="4" class="m-th">
                <el-tooltip content="园区" placement="top"
                  ><span class="count-style">园区</span></el-tooltip
                >
              </el-col>
              <el-col :span="8" class="m-td">
                <span>{{ orderContent.order_park }}</span>
              </el-col>
              <el-col :span="4" class="m-th">
                <el-tooltip content="订单类型" placement="top"
                  ><span class="count-style">订单类型</span></el-tooltip
                >
              </el-col>
              <el-col :span="8" class="m-td">
                <span>{{ orderContent.order_reg_type }}</span>
              </el-col>
              <el-col :span="4" class="m-th">
                <el-tooltip content="派单时间" placement="top"
                  ><span class="count-style">派单时间</span></el-tooltip
                >
              </el-col>
              <el-col :span="8" class="m-td">
                <span>
                <!-- {{ orderContent.assign_at }} -->
                <date-formatter :date-value="orderContent.assign_at"></date-formatter>
                </span>
              </el-col>
              <!-- <el-col v-if="orderContent.order_reg_type === '单品'" :span="4" class="m-th">
                <el-tooltip content="单品" placement="top"><span
                    class="count-style">单品</span></el-tooltip>
              </el-col>
              <el-col v-if="orderContent.order_reg_type === '单品'" :span="20" class="m-td">
                <span v-for="item in orderItems" :key="item.item_id">{{item.item_name}} </span>
              </el-col> -->
              <el-col :span="4" class="m-th">
                <el-tooltip content="服务状态" placement="top"
                  ><span class="count-style">服务状态</span></el-tooltip
                >
              </el-col>
              <el-col :span="8" class="m-td">
                <span>{{ orderContent.service_status }}</span>
              </el-col>
              <el-col :span="4" class="m-th">
                <el-tooltip content="顾问" placement="top"
                  ><span class="count-style">顾问</span></el-tooltip
                >
              </el-col>
              <el-col :span="8" class="m-td">
                <span>{{ orderContent.advisor }}</span>
              </el-col>
              <el-col :span="4" class="m-th">
                <el-tooltip content="订单转化人" placement="top"
                  ><span class="count-style">订单转化人</span></el-tooltip
                >
              </el-col>
              <el-col :span="8" class="m-td">
                <span>{{ orderContent.trans }}</span>
              </el-col>
              <el-col :span="4" class="m-th">
                <el-tooltip content="套餐" placement="top"
                  ><span class="count-style">套餐</span></el-tooltip
                >
              </el-col>
              <el-col :span="8" class="m-td">
                <span>{{ orderContent.proxy_meal }}</span>
              </el-col>
              <el-col :span="4" class="m-th">
                <el-tooltip content="退款申请人" placement="top"
                  ><span class="count-style">退款申请人</span></el-tooltip
                >
              </el-col>
              <el-col :span="8" class="m-td">
                <span>{{ orderContent.refund_per }}</span>
              </el-col>
              <el-col :span="4" class="m-th">
                <el-tooltip content="退款原因" placement="top"
                  ><span class="count-style">退款原因</span></el-tooltip
                >
              </el-col>
              <el-col :span="20" class="m-td">
                <span>{{ orderContent.refund_cause }}</span>
              </el-col>
              <el-col :span="4" class="m-th">
                <el-tooltip content="退款叙述" placement="top"
                  ><span class="count-style">退款叙述</span>
                </el-tooltip>
              </el-col>
              <el-col :span="20" class="m-td">
                <span>{{ orderContent.reason_for_return_info }}</span>
              </el-col>
            </el-row>
            <el-divider content-position="left">退款进度</el-divider>
            <el-timeline>
              <el-timeline-item
                :timestamp="orderContent.refund_verifi_at"
                placement="top"
                :color="orderContent.refund_verifi_at ? '#67c23a' : ''"
              >
                <el-card>审核</el-card>
              </el-timeline-item>
              <el-timeline-item
                :timestamp="orderContent.refund_sub_date"
                placement="top"
                :color="orderContent.refund_sub_date ? '#67c23a' : ''"
              >
                <el-card>提交申请</el-card>
              </el-timeline-item>
              <el-timeline-item
                :timestamp="orderContent.refunder_status_date"
                placement="top"
                :color="orderContent.refunder_status_date ? '#67c23a' : ''"
              >
                <el-card>退款完成</el-card>
              </el-timeline-item>
            </el-timeline>
          </el-tab-pane>
          <el-tab-pane label="反馈记录" name="newreflect">
            <feed-back
              :orderId="refundOrderId"
              :type="1"
              :isShow="true"
              :cType="checkType"
            ></feed-back>
          </el-tab-pane>
          <el-tab-pane label="历史反馈记录" name="reflect">
            <!-- <el-row>
              <el-col :span="6" class="m-label">联系方式</el-col>
              <el-col :span="10">
                <el-select v-model="reflectForm.contact_type" filterable placeholder="请选择" clearable :size="inputSize">
                  <el-option :value="1" label="电话联系"></el-option>
                  <el-option :value="8" label="服务进度"></el-option>
                  <el-option :value="2" label="手机短信"></el-option>
                  <el-option :value="3" label="发送快递"></el-option>
                  <el-option :value="4" label="微信交流"></el-option>
                  <el-option :value="5" label="见面拜谈"></el-option>
                  <el-option :value="6" label="公司洽谈"></el-option>
                  <el-option :value="7" label="优开平台"></el-option>
                  <el-option :value="9" label="QQ沟通"></el-option>
                  <el-option :value="10" label="钉钉沟通"></el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row class="mt-10">
              <el-col :span="6" class="m-label">跟踪后意向</el-col>
              <el-col :span="10">
                <el-select v-model="reflectForm.intention" filterable placeholder="请选择" clearable :size="inputSize">
                  <el-option value="A" label="A"></el-option>
                  <el-option value="B" label="B"></el-option>
                  <el-option value="C" label="C"></el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row class="mt-10" v-if="reflectForm.contact_type === 1">
              <el-col :span="6" class="m-label">通话时长</el-col>
              <el-col :span="10">
                <el-input placeholder="请输入内容" v-model="reflectForm.contact_duration" :size="inputSize">
                  <template slot="append">秒</template>
                </el-input>
              </el-col>
            </el-row>
            <el-row class="mt-10">
              <el-input type="textarea" placeholder="请输入内容" v-model="reflectForm.content"></el-input>
            </el-row>
            <el-row class="mt-10 tr">
              <el-button type="primary" size="mini" @click="handleReflect">添加</el-button>
            </el-row> -->
            <!-- <el-divider content-position="left">反馈历史</el-divider> -->
            <el-row>
              <el-timeline>
                <el-timeline-item
                  v-for="reflect in reflects"
                  :key="reflect.id"
                  :timestamp="reflect.created_at"
                  placement="top"
                >
                  <el-card>
                    <h5>
                      {{ reflect.executor }} 通过 {{ reflect.contact_type }} 进行联系
                      <span v-if="reflect.contact_duration">
                        沟通了 {{ reflect.contact_duration }} 秒</span
                      >
                    </h5>
                    <p>{{ reflect.reflect_content }}</p>
                  </el-card>
                </el-timeline-item>
              </el-timeline>
            </el-row>
          </el-tab-pane>
          <el-tab-pane name="relationOrders">
            <el-badge slot="label" :value="orderStatusCount" class="setBadge"
              >相关订单</el-badge
            >
            <el-table :data="relationOrders" style="width: 100%" border>
              <el-table-column prop="order_num" label="订单号"></el-table-column>
              <el-table-column
                prop="order_reg.order_reg_name"
                label="订单类型"
              ></el-table-column>
              <el-table-column
                :prop="'consultant' ? 'advisor.username' : 'consultant'"
                label="顾问"
              ></el-table-column>
              <el-table-column prop="order_status" label="订单状态"></el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-drawer>
    <el-drawer
      title="审核提交"
      :visible.sync="reviewDrawer"
      direction="rtl"
      :before-close="handleReviewBeforeClose"
      size="40%"
    >
      <div class="m-tabs-content">
        <el-row>
          <el-col :span="6" class="m-label">是否一致:</el-col>
          <el-col :span="18">
            <el-select v-model="reviewData.fit" placeholder="清选择" :size="inputSize">
              <el-option label="否" :value="1"></el-option>
              <el-option label="是" :value="2"></el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class="m-label">原因归属:</el-col>
          <el-col :span="18">
            <el-select v-model="reviewData.reason" placeholder="清选择" :size="inputSize">
              <el-option label="服务商" :value="1"></el-option>
              <el-option label="客户" :value="2"></el-option>
              <el-option label="其他" :value="3"></el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class="m-label">服务态度:</el-col>
          <el-col :span="18">
            <el-select
              v-model="reviewData.attitude"
              placeholder="清选择"
              :size="inputSize"
            >
              <el-option label="非常满意" :value="1"></el-option>
              <el-option label="满意" :value="2"></el-option>
              <el-option label="不满意" :value="3"></el-option>
              <el-option label="差" :value="4"></el-option>
              <el-option label="很差" :value="5"></el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class="m-label">服务专业度:</el-col>
          <el-col :span="18">
            <el-select
              v-model="reviewData.specialized"
              placeholder="清选择"
              :size="inputSize"
            >
              <el-option label="专业" :value="1"></el-option>
              <el-option label="不专业" :value="2"></el-option>
              <el-option label="非常不专业" :value="3"></el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class="m-label">产品原因:</el-col>
          <el-col :span="18">
            <el-select
              v-model="reviewData.product"
              placeholder="清选择"
              :size="inputSize"
            >
              <el-option label="满足" :value="1"></el-option>
              <el-option label="部分满足" :value="2"></el-option>
              <el-option label="不满足" :value="3"></el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class="m-label">产品报价:</el-col>
          <el-col :span="18">
            <el-select v-model="reviewData.offer" placeholder="清选择" :size="inputSize">
              <el-option label="正好" :value="1"></el-option>
              <el-option label="太高" :value="2"></el-option>
              <el-option label="太低" :value="3"></el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row>
          <el-input
            type="textarea"
            placeholder="原因叙述及客户意见"
            v-model="reviewData.opinion"
          ></el-input>
        </el-row>
      </div>
      <el-row class="bottom-btn">
        <el-button @click="handleReviewSave" size="mini" type="primary">保存</el-button>
      </el-row>
      <div class="m-tabs-content">
        <el-row class="mt-10">
          <el-col :span="12"
            ><span>退款申请时间: {{ reviewShow.refund_date }}</span></el-col
          >
          <el-col :span="12"
            ><span>是否可退款: {{ reviewShow.refundable }}</span></el-col
          >
        </el-row>
        <el-row class="mt-10">
          <el-col :span="12"
            ><span>订单金额: {{ reviewShow.total_amount }}</span></el-col
          >
          <el-col :span="12" v-show="reviewShow.refundable === '部分退款'"
            ><span>退款金额: {{ reviewShow.return_money }}</span></el-col
          >
        </el-row>
        <el-row>
          <el-col :span="12"
            ><span>退款原因: {{ reviewShow.refund_cause }}</span></el-col
          >
          <el-col :span="12"
            ><span>退款优先级: {{ reviewShow.refund_priority }}</span></el-col
          >
        </el-row>
        <el-row>
          <el-col :span="12"
            ><span>反馈来源: {{ reviewShow.feedback_source }}</span></el-col
          >
          <el-col :span="12"
            ><span
              >是否原路退款: {{ reviewShow.is_init_refund === 1 ? "是" : "否" }}</span
            ></el-col
          >
        </el-row>
        <el-row>
          <el-col :span="12"
            ><span>退款银行: {{ reviewShow.receive_bank }}</span></el-col
          >
          <el-col :span="12"
            ><span>退款银行卡号: {{ reviewShow.receive_card_no }}</span></el-col
          >
        </el-row>
        <el-row>
          <el-col :span="12"
            ><span>退款银行账户: {{ reviewShow.receive_card_acc }}</span></el-col
          >
        </el-row>
        <el-row style="margin-top: 0.8rem">
          <el-divider content-position="left">退款叙述</el-divider>
          <p>{{ reviewShow.reason_for_return_info_er }}</p>
          <p class="mt-10">{{ reviewShow.reason_for_return_info }}</p>
        </el-row>
      </div>
    </el-drawer>
    <el-drawer
      title=""
      :visible.sync="memberInfoDrawer"
      direction="rtl"
      :before-close="handleClose_memberInfoDrawer"
      size="50%"
    >
      <template slot="title">
        <span style="color: #409eff; font-size: 0.3rem; font-weight: bold">会员信息</span>
      </template>
      <div style="padding: 0.2em 1.4em; margin-top: 0.3rem">
        <member-info :phone="memberPhone"></member-info>
      </div>
    </el-drawer>
    <el-dialog title="选择分配人员" :visible.sync="dialogVisible" width="30%">
      <div>
        <el-select
          v-model="refund_revisiter"
          filterable
          placeholder="请选择"
          clearable
          size="mini"
        >
          <el-option
            v-for="option in personnel"
            :key="option.id"
            :label="option.username"
            :value="option.id"
          >
          </el-option>
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="handleCloseDialog">确 定</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
import MemberInfo from "common/MemberInfo";
import FeedBack from "common/FeedBack";
import DateFormatter from "common/DateFormatter";
import PhoneCom from 'common/PhoneCom'
import { filterKeywordOptions } from '../../lib/cascaderUtils.js';

export default {
  name: "TycOrderRefund",
  components: { MemberInfo, FeedBack, DateFormatter, PhoneCom},
  props: {
    user: Object,
  },
  data() {
    return {
      activeOpen: "",
      memberPhone: null,
      memberInfoDrawer: false,
      pageNodes: [],
      orderSources: "",
      relationCount: 0,
      fulfill: 0,
      relationOrders: [],
      orderItems: [],
      schedules: [],
      orderContent: {
        order_num: "",
        total_amount: null,
        order_reg_type: "",
        assign_at: "",
        advisor: "",
        trans: "",
        proxy_meal: "",
        order_status: "",
        service_status: "",
        refund_verifi_at: null,
        refund_sub_date: null,
        refunder_status_date: null,
        order_park: "",
        refund_cause: "",
        refund_per: "",
        reason_for_return_info: "",
        reason_for_return_info_er: "",
      },
      meals: [],
      activeName: "info",
      refund_revisiter: null,
      dialogVisible: false,
      multipleSelection: [],
      inputSize: "small",
      refundCount: 0,
      todayCount: 0,
      yesterday: 0,
      todayVerify: 0,
      yesterdayVerify: 0,
      searcher: null,
      refunder: "refund_per",
      searchLoading: false,
      searchCategories: [],
      searchArr: {
        assign_at: "",
        refund_date: "",
        refunder: null,
        consultant: null,
        refund_status: null,
        refund_cause_id: [],
        convert: null,
        fit: null,
        is_member: "",
        refund_order: "",
      },
      orders: [],
      pageData: [],
      causes: [],
      col: [
        {
          label: "订单号",
          prop: "order_num",
          sort: false,
          fixed: "left",
          tooltip: true
        },
        {
          label: "订单状态",
          prop: "order_status",
          sort: false,
          fixed: "left",
          width: "120",
        },
        {
          label: "最近联系时间",
          prop: "contact_time",
          sort: true,
        },
        {
          label: "申请时间",
          prop: "refund_date",
          sort: true,
        },
        {
          label: "申请人",
          prop: "refunder",
          showExport: false,
        },
        {
          label: "转化人",
          prop: "trans",
        },
        {
          label: "审核人",
          prop: "refund_verify_name",
          sort: false,
        },
        {
          label: "顾问",
          prop: "advisor",
          sort: false,
        },
        {
          label: "客户姓名",
          prop: "customer_name",
          sort: false,
          width: "100px",
        },
        {
          label: "手机号码",
          prop: "customer_phone",
          sort: false,
          width: "170px",
        },
        {
          label: "是否会员",
          prop: "is_member",
          sort: false,
          width: "100px",
        },
        // {
        //   label: '跟踪人',
        //   prop: 'reviewer',
        //   sort: false
        // },
        // {
        //   label: '跟踪后意向',
        //   prop: 'intention',
        //   sort: true
        // },
        {
          label: "订单类型",
          prop: "order_reg",
          sort: false,
          width: "100px",
        },
        {
          label: "订单金额",
          prop: "total_amount",
          sort: false,
          width: "100px",
        },
        {
          label: "退款金额",
          prop: "return_money",
          sort: false,
          width: "100px",
        },
      ],
      pageOption: {
        total: 0,
        currentPage: 1,
        pageSize: 30,
      },
      logDrawer: false,
      reflects: [],
      reflectForm: {
        index: null,
        id: 0,
        content: "",
        contact_type: null,
        contact_duration: 0,
        intention: "",
      },
      personnel: [],
      orderRegs: [],
      reviewDrawer: false,
      reviewData: {
        id: null,
        index: null,
        fit: null,
        reason: null,
        attitude: null,
        specialized: null,
        product: null,
        offer: null,
        opinion: "",
      },
      reviewShow: {
        refundable: "",
        refund_cause: "",
        refund_date: "",
        refund_priority: "",
        feedback_source: "",
        reason_for_return_info: "",
        reason_for_return_info_er: "",
        is_init_refund: null,
        receive_bank: "",
        receive_card_no: "",
        receive_card_acc: "",
        total_amount: 0,
        return_money: 0,
      },
      assignPicker: {
        shortcuts: [
          {
            text: "今天",
            onClick: (picker) => {
              const todayDate = this.today();
              picker.$emit("pick", todayDate);
            },
          },
          {
            text: "昨天",
            onClick: (picker) => {
              const yesterDate = this.yesterday();
              picker.$emit("pick", yesterDate);
            },
          },
          {
            text: "本周",
            onClick: (picker) => {
              const thisWeekDate = this.thisWeek();
              picker.$emit("pick", thisWeekDate);
            },
          },
          {
            text: "上周",
            onClick: (picker) => {
              const prevWeekDate = this.prevWeek();
              picker.$emit("pick", prevWeekDate);
            },
          },
          {
            text: "本月",
            onClick: (picker) => {
              const thisMonDate = this.thisMon();
              picker.$emit("pick", thisMonDate);
            },
          },
          {
            text: "上月",
            onClick: (picker) => {
              const lastMonDate = this.lastMon();
              picker.$emit("pick", lastMonDate);
            },
          },
        ],
      },
      refundPicker: {
        shortcuts: [
          {
            text: "今天",
            onClick: (picker) => {
              const todayDate = this.today();
              picker.$emit("pick", todayDate);
            },
          },
          {
            text: "昨天",
            onClick: (picker) => {
              const yesterDate = this.yesterday();
              picker.$emit("pick", yesterDate);
            },
          },
          {
            text: "本周",
            onClick: (picker) => {
              const thisWeekDate = this.thisWeek();
              picker.$emit("pick", thisWeekDate);
            },
          },
          {
            text: "上周",
            onClick: (picker) => {
              const prevWeekDate = this.prevWeek();
              picker.$emit("pick", prevWeekDate);
            },
          },
          {
            text: "本月",
            onClick: (picker) => {
              const thisMonDate = this.thisMon();
              picker.$emit("pick", thisMonDate);
            },
          },
          {
            text: "上月",
            onClick: (picker) => {
              const lastMonDate = this.lastMon();
              picker.$emit("pick", lastMonDate);
            },
          },
        ],
      },
      refundOrderId: null,
      checkType: this.$feedBackConfig.refund_chat,
      additionalData: { value: '自助下单', label: '自助下单' },
    };
  },
  watch: {
    // search: function () {
    //   this.pageOption.total = this.search ? this.searchTotal() : this.orders.length
    //   this.pageOption.searchCurrentPage = 1
    // }
  },
  computed: {
    // pageData: function () {
    //   let currentPage = this.search ? this.pageOption.searchCurrentPage : this.pageOption.currentPage
    //   return this.orders.filter(data => !this.search || data.order_num.toLowerCase().includes(this.search.toLowerCase()) || data.customer_phone.toLowerCase().includes(this.search.toLowerCase())).slice(this.pageOption.pageSize * (currentPage - 1), this.pageOption.pageSize * currentPage)
    // },
    searchStr: function () {
      let str = "";
      for (let key in this.searchArr) {
        str += "&" + key + "=" + this.searchArr[key];
      }
      return str;
    },
    orderStatusCount: {
      get: function () {
        return this.fulfill + "/" + this.relationCount;
      },
    },
    collapse() {
      return this.$store.state.collapse;
    },
    personnelConvert() {
      return [this.additionalData, ...this.personnel ]
    }
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickCollapseOutSide);
  },
  methods: {
    handelGetOrders() {
      this.$axios
        .get(
          "/api/admin/tyc_analysis/refund?page=" +
            this.pageOption.currentPage +
            "&pagesize=" +
            this.pageOption.pageSize +
            this.searchStr
        )
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.pageNodes = data.data.pageNodes;
            this.pageData = data.data.orders.data;
            this.pageOption.total = data.data.orders.total;
            // 参数数据
            this.refundCount = data.data.orders.total;
            this.todayCount = data.data.todayCount;
            this.yesterday = data.data.yesterday;
            this.todayVerify = data.data.todayVerify;
            this.yesterdayVerify = data.data.yesterdayVerify;
            this.personnel = data.data.personnel;
            this.causes = data.data.causes;
            this.meals = data.data.meals;
            this.orderRegs = data.data.orderRegs;
          }
        });
    },
    handleClickCollapseOutSide(event) {
      const elCollapse = this.$el.querySelector('.el-collapse');
      if (elCollapse && !elCollapse.contains(event.target)) {
        this.activeOpen = '';
      }
    },
    handleASearSub() {
      this.pageOption.currentPage = 1;
      this.activeOpen = "";
      this.handelGetOrders();
    },
    handleASearClear() {
      this.searchArr.assign_at = "";
      this.searchArr.refund_date = "";
      this.searchArr.refunder = null;
      this.searchArr.consultant = null;
      this.searchArr.refund_status = null;
      this.searchArr.refund_cause_id = [];
      this.searchArr.convert = null;
      this.searchArr.fit = null;
      this.searchArr.is_member = "";
      this.pageOption.currentPage = 1;
      this.activeOpen = "";
      this.handelGetOrders();
    },
    handleSearchCfcategory(query) {
      this.pageOption.currentPage = 1;
      this.searchArr.refund_order = query;
      setTimeout(() => {
        this.handelGetOrders();
      });
    },
    handleSizeChange(val) {
      this.pageOption.pageSize = val;
      this.handelGetOrders();
    },
    handleCurrentChange(val) {
      this.pageOption.currentPage = val;
      this.handelGetOrders();
    },
    handelRefundRefuse(index, row) {
      this.$axios.post("/api/admin/refund/refuse/", { id: row.id }).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.handelGetOrders();
          this.$message.success(data.msg);
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    filterOptions(node, keyword) {
  return filterKeywordOptions(node, keyword);
},
    handelFeedbackOpen(index, id) {
      setTimeout(() => {
        this.refundOrderId = id;
      }, 100);
      this.logDrawer = true;
      this.$axios.get("/api/admin/tyc_orders/log/" + id).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.reflectForm.index = index;
          this.reflectForm.id = id;
          for (var i = 0; i < this.pageData.length; i++) {
            if (id === this.pageData[i].id) {
              this.reflectForm.intention = this.pageData[i].intention;
            }
          }
          this.reflects = data.data.reflects;
          this.setOrderContent(index);
          this.orderItems = data.data.items;
          this.relationOrders = data.data.relationOrders;
          this.relationCount = data.data.relationOrders.length;
          this.countFulfill(data.data.relationOrders);
          this.orderSources = this.pageData[index].source
            ? this.pageData[index].source.source_name
            : "";
        }
      });
    },
    countFulfill(relationOrders) {
      for (var i = 0; i < relationOrders.length; i++) {
        if (relationOrders[i].service_status === "服务完成") {
          this.fulfill++;
        }
      }
    },
    handleClose_memberInfoDrawer(done) {
      this.memberPhone = null;
      done();
    },
    openMemberInfoDrawer(phone) {
      this.memberInfoDrawer = true;
      setTimeout(() => {
        this.memberPhone = phone;
      }, 0);
    },
    setOrderContent(index) {
      this.orderContent.order_num = this.pageData[index].order_num;
      this.orderContent.total_amount = this.pageData[index].total_amount;
      this.orderContent.order_reg_type = this.getOrderRegTypeName(
        this.pageData[index].order_reg_type
      );
      this.orderContent.assign_at = this.pageData[index].assign_at;
      this.orderContent.advisor = this.pageData[index].advisor
        ? this.pageData[index].advisor.username
        : "";
      this.orderContent.trans = this.pageData[index].trans
        ? this.pageData[index].trans.username
        : "自助下单";
      this.orderContent.proxy_meal = this.pageData[index].proxy_meal
        ? this.getMealName(this.pageData[index].proxy_meal)
        : "无";
      this.orderContent.order_status = this.pageData[index].order_status;
      this.orderContent.service_status = this.pageData[index].service_status;
      this.orderContent.refund_verifi_at = this.pageData[index].refund_verifi_at;
      this.orderContent.refund_sub_date = this.pageData[index].refund_sub_date;
      this.orderContent.refunder_status_date = this.pageData[index].refunder_status_date;
      this.orderContent.order_park = this.pageData[index].order_park;
      this.orderContent.refund_cause = this.pageData[index].refunds
        ? this.pageData[index].refunds.refund_cause
        : "";
      this.orderContent.refund_per = this.pageData[index].refund_per
        ? this.pageData[index].refund_per.username
        : "无";
      this.orderContent.reason_for_return_info = this.pageData[
        index
      ].reason_for_return_info;
      this.orderContent.reason_for_return_info_er = this.pageData[
        index
      ].reason_for_return_info_er;
    },
    getMealName(id) {
      let name = "";
      for (var i = 0; i < this.meals.length; i++) {
        if (this.meals[i].combo_id === id) {
          name = this.meals[i].combo_name;
        }
      }

      return name;
    },
    handleLogBeforeClose(done) {
      this.reflectForm.index = null;
      this.reflectForm.id = 0;
      this.reflectForm.content = "";
      this.reflectForm.contact_type = null;
      this.reflectForm.contact_duration = 0;
      this.reflectForm.intention = "";
      this.reflects = [];
      this.orderItems = [];
      this.relationOrders = [];
      this.relationCount = 0;
      this.fulfill = 0;
      this.orderSources = "";
      this.activeName = "info";
      done();
    },
    handleReflect() {
      if (!this.reflectForm.contact_type) {
        this.$message.error("请选择联系方式");
        return;
      }

      if (
        this.reflectForm.contact_type === 1 &&
        !/(^[1-9]\d*$)/.test(this.reflectForm.contact_duration)
      ) {
        this.$message.error("请填写通话时长，必须为正整数");
        return;
      }

      if (!this.reflectForm.content) {
        this.$message.error("内容不能为空");
        return;
      }

      this.$axios
        .post("/api/admin/tyc_order_reflect", {
          order_id: this.reflectForm.id,
          reflect_content: this.reflectForm.content,
          contact_type: this.reflectForm.contact_type,
          contact_duration: this.reflectForm.contact_duration,
          intention: this.reflectForm.intention,
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.reflects.unshift(data.data);
            this.reflectForm.content = "";
            this.reflectForm.contact_type = null;
            this.reflectForm.contact_duration = 0;
            for (var i = 0; i < this.pageData.length; i++) {
              if (this.reflectForm.id === this.pageData[i].id) {
                this.pageData[i].intention = this.reflectForm.intention;
                this.pageData[i].contact_time = data.data.created_at;
              }
            }
            // this.pageData[this.reflectForm.index].intention = this.reflectForm.intention
            // this.pageData[this.reflectForm.index].contact_time = data.data.created_at
            this.reflectForm.intention = "";
            this.$message.success(data.msg);
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    handelRefundSubmit(index, row) {
      this.$axios.put("/api/admin/refund/sub/" + row.id).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.handelSetRefundSubmit(row.id);
          // this.pageData[index].refund_submit = 2
          this.$message.success(data.msg);
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    handelSetRefundSubmit(id) {
      for (var i = 0; i < this.pageData.length; i++) {
        if (id === this.pageData[i].id) {
          this.pageData[i].refund_status = 2;
        }
      }
    },
    handelComplete(index, row) {
      this.$axios.put("/api/admin/refund/refundComplete/" + row.id).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          for (var i = 0; i < this.pageData.length; i++) {
            if (row.id === this.pageData[i].id) {
              this.pageData[i].refund_status = 3;
            }
          }
          this.$message.success(data.msg);
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    handleExport() {
      // if (this.orders.length === 0) {
      //   this.$message.error("没有数据");
      //   return;
      // }
      this.$axios
        .post(
          "/api/admin/refund/load",
          { searchArr: this.searchArr },
          { responseType: "blob" }
        )
        .then((res) => {
          let blob = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          let objectUrl = window.URL.createObjectURL(blob);
          let link = document.createElement("a");
          let myDate = new Date();
          link.href = objectUrl;
          link.download = "退款订单" + myDate.toLocaleDateString() + ".csv";
          link.click();
          setTimeout(function () {
            window.URL.revokeObjectURL(objectUrl);
          }, 100);
        });
    },
    tableColumn(prop) {
      let width = "";
      if (prop === "order_num") {
        width = 190;
      }
      if (prop === "contact_time") {
        width = 150;
      }
      if (prop === "intention") {
        width = 100;
      }
      if (prop === "order_status") {
        width = 120;
      }
      if (prop === "refund_date" || prop === "intention") {
        width = 120;
      }
      if (prop === "customer_name") {
        width = 100;
      }
      if (prop === "customer_phone") {
        width = 170;
      }
      if (prop === "is_member") {
        width = 100;
      }
      if (prop === "order_reg") {
        width = 100;
      }
      if (prop === "total_amount") {
        width = 100;
      }
      if (prop === "return_money") {
        width = 100;
      }

      return width;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleAssign() {
      if (this.multipleSelection.length === 0) {
        this.$message.error("请先选择订单");
        return;
      }

      this.dialogVisible = true;
    },
    handleCloseDialog() {
      if (!this.refund_revisiter) {
        this.$message.error("请选择分配人员");
        return;
      }

      let ids = [];

      this.multipleSelection.forEach((row) => {
        ids.push(row.id);
      });

      this.$axios
        .put("/api/admin/refund/assign", {
          ids: ids,
          refund_revisiter: this.refund_revisiter,
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.dialogVisible = false;
            let name = this.getPeopleName(this.refund_revisiter);
            this.setRevisiter(ids, name);
            this.refund_revisiter = null;
            this.multipleSelection = [];
            this.$refs.multipleTable.clearSelection();
            this.$message.success(data.msg);
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    getPeopleName(val) {
      let obj = {};
      let name = "";
      obj = this.personnel.find((item) => {
        return item.id === val;
      });

      if (obj) name = obj.username;

      return name;
    },
    setRevisiter(ids, name) {
      for (var i = 0; i < ids.length; i++) {
        this.pageData.forEach((row) => {
          if (row.id === ids[i]) {
            row.refund_revisiter = ids[i];
            row.reviewer = { id: ids[i], username: name };
          }
        });
      }
    },
    getOrderRegTypeName(val) {
      let obj = {};
      let name = "";
      obj = this.orderRegs.find((item) => {
        return item.order_reg_id === val;
      });
      if (obj) name = obj.order_reg_name;
      return name;
    },
    copyUrl(data) {
      let url = data;
      let oInput = document.createElement("input");
      oInput.value = url;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      // console.log(oInput.value)
      document.execCommand("Copy"); // 执行浏览器复制命令
      this.$message({
        message: "已成功复制到剪切板",
        type: "success",
      });
      oInput.remove();
    },
    handleReviewBeforeClose(done) {
      this.clearReviewData();
      done();
    },
    clearReviewData() {
      this.reviewData.id = null;
      this.reviewData.index = null;
      this.reviewData.fit = null;
      this.reviewData.reason = null;
      this.reviewData.attitude = null;
      this.reviewData.specialized = null;
      this.reviewData.product = null;
      this.reviewData.offer = null;
      this.reviewData.opinion = "";
      this.reviewShow.refundable = "";
      this.reviewShow.refund_cause = "";
      this.reviewShow.refund_date = "";
      this.reviewShow.refund_priority = "";
      this.reviewShow.feedback_source = "";
      this.reviewShow.reason_for_return_info = "";
      this.reviewShow.reason_for_return_info_er = "";
      (this.reviewShow.is_init_refund = null),
        (this.reviewShow.receive_bank = ""),
        (this.reviewShow.receive_card_no = ""),
        (this.reviewShow.receive_card_acc = "");
      this.reviewShow.total_amount = 0;
      this.reviewShow.return_money = 0;
    },
    handelReview(index, row) {
      this.reviewData.id = row.id;
      this.reviewData.index = index;
      this.reviewData.fit = row.fit;
      this.reviewData.reason = row.reason;
      this.reviewData.attitude = row.attitude;
      this.reviewData.specialized = row.specialized;
      this.reviewData.product = row.product;
      this.reviewData.offer = row.offer;
      this.reviewData.opinion = row.opinion;
      this.reviewShow.refundable = row.refundable;
      this.reviewShow.refund_cause = row.refunds ? row.refunds.refund_cause : "";
      this.reviewShow.refund_date = row.refund_date;
      this.reviewShow.refund_priority = row.refund_priority;
      this.reviewShow.feedback_source = row.feedback_source;
      this.reviewShow.reason_for_return_info = row.reason_for_return_info;
      this.reviewShow.reason_for_return_info_er = row.reason_for_return_info_er;
      this.reviewShow.is_init_refund = row.is_init_refund;
      this.reviewShow.receive_bank = row.receive_bank;
      this.reviewShow.receive_card_no = row.receive_card_no;
      this.reviewShow.receive_card_acc = row.receive_card_acc;
      this.reviewShow.total_amount = row.total_amount;
      this.reviewShow.return_money = row.return_money;
      this.reviewDrawer = true;
    },
    handleReviewSave() {
      if (!this.reviewData.fit) {
        this.$message.error("请选择是否一致");
        return;
      }

      this.$axios
        .put("/api/admin/refund_verify/" + this.reviewData.id, this.reviewData)
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.$message.success(data.msg);
            this.reviewDrawer = false;
            this.handelSetReviewSubmit(this.reviewData.id);
            this.clearReviewData();
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    handelSetReviewSubmit(id) {
      for (var i = 0; i < this.pageData.length; i++) {
        if (id === this.pageData[i].id) {
          this.pageData[i].refund_status = 1;
          this.pageData[i].fit = this.reviewData.fit;
          this.pageData[i].reason = this.reviewData.reason;
          this.pageData[i].attitude = this.reviewData.attitude;
          this.pageData[i].specialized = this.reviewData.specialized;
          this.pageData[i].product = this.reviewData.product;
          this.pageData[i].offer = this.reviewData.offer;
          this.pageData[i].opinion = this.reviewData.opinion;
        }
      }
    },
    transStatus(sta) {
      var arr = ["未知", "未完成", "已完成"];

      return arr[sta];
    },
    thisWeek() {
      var Nowdate = new Date();
      var WeekFirstDay = new Date(Nowdate - (Nowdate.getDay() - 1) * 86400000);

      var M = Number(WeekFirstDay.getMonth()) + 1;
      var start = WeekFirstDay.getFullYear() + "-" + M + "-" + WeekFirstDay.getDate();

      var WeekLastDay = new Date((WeekFirstDay / 1000 + 6 * 86400) * 1000);
      var Mon = Number(WeekLastDay.getMonth()) + 1;
      var end = WeekLastDay.getFullYear() + "-" + Mon + "-" + WeekLastDay.getDate();

      return [start, end];
    },
    prevWeek() {
      var end = new Date();
      var start = new Date();
      var lastWeek = new Date().getDay(); // 获取今日周几
      // 开始时间(上周一与今天间隔的天数)
      start.setTime(start.getTime() - 3600 * 1000 * 24 * (7 + lastWeek - 1)); // 减1是因为以下时间戳操作,例如周二,但是时间戳还在周一后的xx小时
      // 结束时间(上周末与今天间隔的天数)
      end.setTime(end.getTime() - 3600 * 1000 * 24 * lastWeek);

      return [start, end];
    },
    today() {
      return [new Date(), new Date()];
    },
    yester() {
      var date = new Date();
      date.setTime(date.getTime() - 3600 * 1000 * 24);

      return [date, date];
    },
    thisMon() {
      var end = new Date();
      var start = new Date();
      // 方法1
      var endDay = new Date().getDate() - 1; // 获取今日几号,减1是因为以下时间戳操作,例如今日16号,但是时间戳还在15号后的xx小时
      start.setTime(start.getTime() - 3600 * 1000 * 24 * endDay);
      // 方法2
      // start.setDate(1) //setDate(1)表示设置开始时间为本月1号,此办法同样可以实现
      return [start, end];
    },
    lastMon() {
      var end = new Date();
      var start = new Date();
      var year = new Date().getFullYear(); // 获取年份
      let month = new Date().getMonth(); // 获取月份
      month = month === 0 ? 1 : month; // 特殊处理:如果为1月 则下方取1月的天数
      var febDays = year % 4 ? 29 : 28; // 判断今年是否为闰年,如是则二月天数为29天,反之为28天
      let days = [31, febDays, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]; // 罗列12个月的天数
      start.setDate(1 - days[month - 1]); // setDate(1)表表示设置为本月1号,故 本月1号 - 上月天数 = 上月1号
      end.setDate(1 - 1); // 以此得出,本月1号 - 1天 = 上月最后一天

      return [start, end];
    },
  },
  mounted() {
    this.handelGetOrders();
    document.addEventListener('click', this.handleClickCollapseOutSide);
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl'
@import '~styles/vertical.styl'
.el-drawer__wrapper >>> .el-drawer
  overflow-y: auto
.tycOrderRefund >>> .el-table__header th
  color: #333333
  background-color: #ECF4FF
.tycOrderRefund >>> .el-timeline-item__node--normal
  left: 0
.tycOrderRefund >>> .el-badge__content.is-fixed
  top: .22rem
  right: .06rem
.tycOrderRefund
  marginLeft()
  max-height: 100vh;
  .header-style
    z-index: 2;
    height: 125px !important
    padding: 0px !important
  .main-style
    z-index: 1;
    padding: 0px !important
    // overflow-y: auto
  .footer-style
    text-align: right
    .el-pagination
      padding-top: 25px
  .hide-style
    display: inherit
    overflow: hidden
    text-overflow: ellipsis
    white-space: nowrap
.tycOrderRefund >>> .el-table th>.cell
  padding-left: .28rem
.el-select, .el-cascader
  width: 100%
.m-tabs-content
  padding: 0 .2rem 0 .4rem
  .m-label
    line-height: .64rem
  .el-row
    margin-bottom: .4rem
.el-card__body p
  margin-top: .4rem
.tr
  text-align: right
.tc
  text-align: center
.mt-10
  margin-top: .2rem
.mt-50
  margin-top: 1rem
.mb-10
  margin-bottom: .2rem
.mb-20
  margin-bottom: .4rem
.ml-10
  margin-left: .2rem
.el-collapse
  border-bottom 0
  border-top 0
.el-collapse >>> .el-collapse-item__header
  color: #4C87FC
  font-weight bold
.el-collapse >>> .el-collapse-item__arrow
  color: #4C87FC
.search-row .el-col
  margin-bottom: .2rem
.el-date-editor
  width: 100% !important
.check-succ
  color: #67C23A
.bottom-btn
  padding: .2rem
  text-align: right

.ellipsis-link {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.m-tab {
  border-top: 1px solid #dee2e6;
  border-left: 1px solid #dee2e6;
}

.m-th {
  height: 42px;
  line-height: 42px;
  padding: 0 5px;
  border-bottom: 1px solid #dee2e6;
  color: #909399;
  background: #fafafa;
}

.m-td {
  height: 42px;
  line-height: 42px;
  padding: 0 5px;
  border-left: 1px solid #dee2e6;
  border-right: 1px solid #dee2e6;
  border-bottom: 1px solid #dee2e6;
}
.AIdrawer .drawer-title {
  background-color: #ecf5ff;
  padding: 10px;
  color: #409EFF;
}
</style>



// WEBPACK FOOTER //
// src/pages/tyc_order_refund/TycOrderRefund.vue